import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { CartProvider } from '@/features/cart/cart-context'
import { CartDrawer } from '@/features/cart/CartDrawer'
import { PublicHeader } from './PublicHeader'
import { PublicFooter } from './PublicFooter'
import { WhatsAppFloat } from './WhatsAppFloat'
import { cn } from '@/lib/utils'

const STOREFRONT_THEME_KEY = 'mmc_storefront_theme'

export function PublicLayout() {
  // El Sheet del carrito se porta a este nodo (en vez de document.body, el default de
  // Radix) para que herede las variables CSS de .storefront-root — si portara al body
  // quedaría fuera del árbol con tema propio y caería al violeta del admin.
  const [themeRoot, setThemeRoot] = useState<HTMLDivElement | null>(null)

  // La tienda siempre abre en claro por defecto, sin importar el tema del
  // sistema — el oscuro es opt-in manual desde el botón del header, y esa
  // elección se recuerda entre visitas.
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === 'undefined') return false
    return localStorage.getItem(STOREFRONT_THEME_KEY) === 'dark'
  })

  useEffect(() => {
    localStorage.setItem(STOREFRONT_THEME_KEY, isDark ? 'dark' : 'light')
  }, [isDark])

  return (
    <CartProvider>
      <div ref={setThemeRoot} className={cn('storefront-root flex flex-col font-sans', isDark && 'theme-dark')}>
        <PublicHeader container={themeRoot} isDark={isDark} onToggleDark={() => setIsDark((v) => !v)} />
        <main className="flex-1">
          <Suspense fallback={<PageLoading />}>
            <Outlet />
          </Suspense>
        </main>
        <PublicFooter />
        <WhatsAppFloat />
        <CartDrawer container={themeRoot} />
      </div>
    </CartProvider>
  )
}

function PageLoading() {
  return (
    <div className="flex min-h-96 items-center justify-center text-sm text-muted-foreground">Cargando…</div>
  )
}
